<script lang="ts" setup>
</script>

<template>
  <UTable
    :sortingOptions="{
      manualSorting: true,
    }"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps ?? {}"
      />
    </template>
  </UTable>
</template>
